import React from 'react';
import PropTypes from 'prop-types';
import useWindowSize from 'hooks/useWindowSize';
import { SCREEN_SIZES } from 'style';
import { Badge, BadgeDescription } from './styled';

const BenefitBadge = React.forwardRef(
  (
    {
      name,
      description,
      icon,
      id,
      selectedBenefit,
      setSelectedBenefit,
      openedBadgesIds,
      setOpenedBadgesIds,
      isBadgeClicked,
      setIsBadgeClicked
    },
    ref
  ) => {
    const { width } = useWindowSize();
    const isMobile = width <= SCREEN_SIZES.tabletLandscape;
    const isOpen = openedBadgesIds.some((badgeId) => badgeId === id);

    const handleClickMobile = () => {
      const newOpenedBadgeIds = [...openedBadgesIds];

      const badgeIsAlreadyOpened = newOpenedBadgeIds.some((badgeId) => badgeId === id);

      if (badgeIsAlreadyOpened) {
        const badgeIndex = newOpenedBadgeIds.indexOf(id);

        newOpenedBadgeIds.splice(badgeIndex, 1);
        setOpenedBadgesIds(newOpenedBadgeIds);
      } else {
        newOpenedBadgeIds.push(id);
        setOpenedBadgesIds(newOpenedBadgeIds);
      }
    };

    const handleClickDesktop = () => {
      setIsBadgeClicked(true);
      setSelectedBenefit(id);
    };

    return (
      <>
        <Badge
          ref={ref}
          onClick={() => (isMobile ? handleClickMobile() : handleClickDesktop())}
          onMouseEnter={() => !isMobile && !isBadgeClicked && setSelectedBenefit(id)}
          $isSelected={isMobile ? isOpen : selectedBenefit === id}
        >
          {icon}
          <span>{name}</span>
        </Badge>

        {isMobile && (
          <BadgeDescription
            animate={{
              height: isOpen ? 'auto' : 0,
              marginBottom: isOpen || !isMobile ? 0 : 22,
              transition: { duration: 0.35 }
            }}
            initial={{ height: 0 }}
          >
            <p>{description}</p>
          </BadgeDescription>
        )}
      </>
    );
  }
);

BenefitBadge.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  id: PropTypes.number.isRequired,
  selectedBenefit: PropTypes.number.isRequired,
  setSelectedBenefit: PropTypes.func.isRequired,
  openedBadgesIds: PropTypes.array.isRequired,
  setOpenedBadgesIds: PropTypes.func.isRequired,
  isBadgeClicked: PropTypes.bool.isRequired,
  setIsBadgeClicked: PropTypes.func.isRequired
};

export default BenefitBadge;
